// Small pure formatters for Storm Mode readouts. RN-portable (no DOM).

/** ms remaining → "1h 12m" / "12m" / "<1m" / "expired". */
export function formatCountdown(ms: number): string {
  if (ms <= 0) return 'expired'
  const totalMin = Math.floor(ms / 60_000)
  if (totalMin < 1) return '<1m'
  const h = Math.floor(totalMin / 60)
  const m = totalMin % 60
  if (h <= 0) return `${m}m`
  return `${h}h ${m}m`
}

/** Severity rank for an IBW damage-threat tag (higher = louder). */
export function damageRank(threat: string | null): number {
  switch (threat) {
    case 'CATASTROPHIC':
      return 3
    case 'DESTRUCTIVE':
      return 2
    case 'CONSIDERABLE':
      return 1
    default:
      return 0
  }
}

/** Lower-case CSS modifier suffix for a damage threat ("destructive"), or null. */
export function damageClass(threat: string | null): string | null {
  return threat ? threat.toLowerCase() : null
}
